import { UsersCanAddList } from "services/clienthub/clienthub.types";
import { RequestInfo } from "store/slice/store.types";
import { Pagination } from "types/global";

export type ConvertedUsersList = {
    data: ConvertedUsersListData[];
    meta: Pagination;
    status: RequestInfo;
};

export type ConvertedUsersListData = {
    id: number;
    name: string;
    username: string;
    email: string;
    company: string;
    position: string;
    activeOn: Date | null;
    linkedinId: string | null;
    hubs: { id: number; name: string }[];
    checked: boolean;
    person_id: number | null;
};

export const convertUsersList = (data: UsersCanAddList[]): ConvertedUsersListData[] => {
    return data.map((user) => {
        return {
            id: user.id,
            name: user.name || "",
            username: user.username || "",
            company: user.job_company_name || "",
            email: user.email || "",
            position: user.job_title || "",
            activeOn: user.last_active_utc,
            linkedinId: user.person.linkedin_id,
            hubs: user.orgs.map((org) => ({ id: org.id, name: org.name || "" })),
            checked: false,
            person_id: user.person.id,
        };
    });
};
